import { type MapTypeFilter } from '@/components/game/map/useMapTypeFilter'
import { LEGEND_ENTRIES } from '@/components/game/map/mapMarkers'

/**
 * Légende cliquable de la carte : chaque bucket est un toggle `aria-pressed`
 * (multi-sélection) qui met en évidence les îles de ce type (les autres sont
 * atténuées dans `MapScene`). Un bouton « Tout » réinitialise (set vide = tout
 * visible). Mobile-first : cibles ≥ 32 px, wrap sur viewport étroit, état lisible
 * sans survol. Source des buckets : `LEGEND_ENTRIES` (= `islandLegendKey`).
 */
export function MapLegend({ filter }: { filter: MapTypeFilter }) {
  const allActive = filter.active.size === 0
  return (
    <div
      className="flex flex-wrap items-center gap-2 rounded-2xl border border-sand-500/20 bg-gradient-to-b from-ocean-700/30 to-[#06222b]/40 p-3 text-xs text-ocean-200"
      role="group"
      aria-label="Filtrer par type d'île"
    >
      <button
        type="button"
        aria-pressed={allActive}
        onClick={filter.reset}
        className={`min-h-8 px-3 rounded-full border font-semibold transition-colors ${
          allActive
            ? 'border-sand-300/60 bg-sand-300/15 text-sand-100'
            : 'border-sand-500/20 text-ocean-200 hover:border-sand-300/40'
        }`}
      >
        Tout
      </button>
      {LEGEND_ENTRIES.map(([key, meta]) => {
        const { Icon } = meta
        const on = filter.isActive(key)
        return (
          <button
            key={key}
            type="button"
            aria-pressed={on}
            onClick={() => filter.toggle(key)}
            className={`min-h-8 inline-flex items-center gap-1.5 pl-1.5 pr-2.5 rounded-full border transition-colors ${
              on
                ? 'border-sand-300/60 bg-sand-300/15 text-sand-100'
                : 'border-sand-500/20 text-ocean-200 hover:border-sand-300/40'
            }`}
          >
            <span
              className="inline-grid place-items-center w-5 h-5 rounded-full"
              style={{ border: `1.5px solid ${meta.color}`, background: 'rgba(6,34,43,.6)', color: meta.color }}
            >
              <Icon className="w-3 h-3" />
            </span>
            {meta.label}
          </button>
        )
      })}
    </div>
  )
}
